import { parse, parseISO } from 'date-fns';

export function parseDate(date: Date | string, local: boolean = true, keepTime: boolean = false): Date {
  const inputFormat = 'yyyy-MM-dd';

  if (typeof date === 'string') {
    const isISO = date.includes('T') && date.includes('Z');
    if (isISO) {
      return local ? removeTimeZone(parseISO(date), keepTime) : parseISO(date);
    }

    return local ? parse(date, inputFormat, new Date()) : new Date(date);
  }

  return local ? removeTimeZone(date, keepTime) : new Date(date);
}

function removeTimeZone(date: Date, keepTime?: boolean) {
  return keepTime
    ? new Date(
        date.getUTCFullYear(),
        date.getUTCMonth(),
        date.getUTCDate(),
        date.getUTCHours(),
        date.getUTCMinutes(),
        date.getUTCSeconds()
      )
    : new Date(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate(), 0, 0, 0);
}
